import { createContext, useContext } from "react";
import { useCatalog } from "@/data/CatalogProvider";

/**
 * Archived products (and the products of archived spaces) are read-only. Views that show their items wrap
 * their content in `<ReadOnlyProvider value>`; editing controls (pickers, title and description editors,
 * comment composer, drag and drop, create buttons) read it with `useReadOnly()` and render plain values instead.
 * The server refuses writes anyway (`product_archived`) and `data/mutations.ts` stops them before any request.
 */
const ReadOnlyContext = createContext(false);

export const ReadOnlyProvider = ReadOnlyContext.Provider;

/** True inside a view of an archived product. */
export function useReadOnly(): boolean {
  return useContext(ReadOnlyContext);
}

/** Whether a product is archived (by id), for views that know the product but not the context. */
export function useProductArchived(productId: string | null | undefined): boolean {
  return useCatalog().isArchived(productId);
}
